/**
 * Mã lỗi khi gọi api getDetailRoom
 */
export const ERROR_CODE_GET_DETAIL_ROOM = {
    ROOM_NOT_EXISTED: "ROOM_NOT_EXISTED"
};
export const STATUS_CODE_ROOM = {
    PROGRESS: "progress",
    NOT_START: "not_start",
    END: "end"
};
export const VALIDATE_USER_NAME = {
    MAX_LENGTH: 64
};
export const ERROR_CODE_JOIN_ROOM = {
    PASSWORD_REQUIRED: "conference.passwordRequired",
    ROOM_LOCKED: "Phòng đã bị khóa bởi chủ phòng",
    ACCESS_DENIED: "conference.connectionError.accessDenied"
};
export const ERROR_CODE_DISPLAY_NAME = {
    NOT_NULL: 'prejoin.errorMissingName',
    MAX_LENGHT: 'prejoin.errorMaxName',
    OK: 'ok'
};
